<template>
  <u-button
    class="add-to-cart-button"
    :kind="buttonType"
    :icon-name="iconName"
    :disabled="disabled"
    v-on="$listeners"
  >
    {{ $t(addToCartButtonLabel) }}</u-button
  >
</template>

<script>
import { UButton } from 'universkin-shared';

const BUTTON_TYPE_OPTIONS = {
  SUBTLE: 'subtle',
  PRIMARY: 'primary'
};

export default {
  name: 'AddToCartButton',
  components: { UButton },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isProductInCart: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addToCartButtonLabel() {
      return this.isProductInCart ? 'action.inYourCart' : 'action.addToCart';
    },
    iconName() {
      return this.isProductInCart ? 'check-circle-green' : '';
    },
    buttonType() {
      return this.isProductInCart ? BUTTON_TYPE_OPTIONS.SUBTLE : BUTTON_TYPE_OPTIONS.PRIMARY;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-to-cart-button {
  --u-icon-color: #30aa20;
}
</style>
